import React from 'react'
import './Spinner.scss'

export interface SpinnerProps {
  size?: 'sm'
}

export const Spinner: React.FC<SpinnerProps> = ({ size }) => {
  const variant = size ? `spinner-${size}` : 'spinner'
  return <div className={variant} role='status' />
}
